import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import 'slick-carousel';
import 'magnific-popup';

export default {
    accordions() {
        // Creating these uniquely since Elementor's accordions are limited
        let accordion = document.querySelectorAll('.accordion-wrapper');

        if (accordion) {
            accordion.forEach((accordion) => {
                let items = accordion.querySelectorAll('.accordion');
                let titles = accordion.querySelectorAll('.accordion__title');
                // get matching content
                let content = accordion.querySelectorAll('.accordion__content');

                // initially set max-height to 0
                content.forEach((content) => {
                    setTimeout(() => {
                        let contentHeight = content.scrollHeight + 20;
                        // set data attribute to content height for later reference
                        content.setAttribute('data-height', contentHeight);
                        content.style.maxHeight = 0;
                    }, 500);
                });

                function toggleAccordion() {
                    const thisItem = this.parentNode;

                    items.forEach(item => {
                        // close other items
                        // if (thisItem !== item) {
                        //     item.classList.remove('active');
                        //     let content = item.querySelector('.accordion__content');
                        //     content.style.maxHeight = 0;
                        // }
                        if (thisItem == item) {
                            // toggle this item
                            let thisContent = thisItem.querySelector('.accordion__content');
                            thisItem.classList.toggle('active');
                            if (thisItem.classList.contains('active')) {
                                let contentHeight = thisContent.dataset.height;
                                thisContent.style.maxHeight = contentHeight + 'px';
                            } else {
                                thisContent.style.maxHeight = 0;
                            }
                            return;
                        }

                        item.classList.remove('active');
                    });
                }

                titles.forEach(title => title.addEventListener('click', toggleAccordion));
            });
        }
    },
    links() {
        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo = '#' + this.href.split('#')[1];
            // Setting 'tabindex' to -1 takes an element out of normal
            // tab flow but allows it to be focused via javascript
            $(skipTo)
                .attr('tabindex', -1)
                .on('blur focusout', function () {
                    // when focus leaves this element,
                    // remove the tabindex attribute
                    $(this).removeAttr('tabindex');
                })
                .focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            if (
                location.pathname.replace(/^\//, '') ===
                this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                var target = $(this.hash);
                var $this = this;
                var header = $('header.site-header');
                var wpAdminBar = $('#wpadminbar');
                var fixedHeaderOffset =
                    parseInt(header.outerHeight()) -
                    parseInt(header.css('padding-top').replace('px', ''));
                // If we're logged in and WP ADmin Bar exists, add it to the offset
                if (wpAdminBar.length) {
                    fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                }
                target = target.length
                    ? target
                    : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate(
                        {
                            scrollTop: target.offset().top - fixedHeaderOffset,
                        },
                        500,
                        function () {
                            if (history.pushState) {
                                history.pushState(null, null, $this.hash);
                            } else {
                                location.hash = $this.hash;
                            }
                        }
                    );
                    e.preventDefault();
                }
            }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /** Break link text to new line when link text is a URL **/
        $(document).ready(function () {
            $('a').each(function () {
                var $this = $(this);
                var innerLink = $this.text();
                if (innerLink.startsWith('http')) {
                    $this.css('word-break', 'break-all');
                }
            });
        });
        /** End Break link text to new line when link text is a URL **/
    },
    itemReveal() {
        // eslint-disable-next-line no-unused-vars
        // var $itemReveals = $('.reveal').waypoint({
        //   handler: function () {
        //     $(this)[0].element.classList.add('revealed');
        //   },
        //   offset: '85%',
        // });

        // Use gsap and ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);
        let reveals = gsap.utils.toArray('.reveal');
        reveals.forEach((reveal) => {
            ScrollTrigger.create({
                trigger: reveal,
                start: 'top 75%', // when the top of the element is 75% from the top of the viewport
                toggleClass: 'revealed',
                // toggleActions: 'play pause resume none',
                once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
            });
        });

        // Stagger reveals with a gsap.timeline() + ScrollTrigger
        let staggers = gsap.utils.toArray('.reveal--staggered');
        staggers.forEach((stagger) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stagger,
                    start: 'top 75%',
                },
            });

            let children = stagger.children; // the immediate children elements of the current target

            tl.to(children, {
                duration: 1,
                y: 0,
                opacity: 1,
                stagger: 0.15,
            });
        });

        // Image reveal - fade in image when it's in view
        // Exclude in Elementor editor
        let body = document.querySelector('body');
        if (!body.classList.contains('elementor-editor-active')) {
            let imageReveals = gsap.utils.toArray('.img-fade-in');
            if (imageReveals) {
                imageReveals.forEach((image) => {
                    ScrollTrigger.create({
                        trigger: image,
                        start: 'top 75%', // when the top of the element is 75% from the top of the viewport
                        toggleClass: 'img-fade-in--faded',
                        // markers: true,
                        // once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
                    });
                });
            }
        }

    },
    slider() {
        let visceralSlider = $('.visceral-slider');

        if (visceralSlider) {
            visceralSlider.each(function () {
                console.log($(this));
                let slider, slide, slidesToShow, centerMode;
                slider = $(this).find(
                    '> .elementor-column-wrap > .elementor-widget-wrap'
                );
                slide =
                    '.visceral-slider > .elementor-column-wrap > .elementor-widget-wrap > *';

                slidesToShow = 1;
                centerMode = true;

                if ($(this).hasClass('posts-list-container')) {
                    slider = $('.visceral-slider .row');
                    slide = '.visceral-slider .row > *';
                    slidesToShow = visceralSlider.attr('data-slides-to-show');
                    centerMode = false;
                }

                slider.slick({
                    slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: true,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: true,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow:
                        '<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><i class="icon-chevron-right"></i></button>',
                    prevArrow:
                        '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><i class="icon-chevron-left"></i></button>',
                    responsive: [
                        {
                            breakpoint: 560, // min-width
                            settings: {
                                slidesToShow: 2,
                                centerMode: centerMode,
                            },
                        },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: slidesToShow,
                            },
                        },
                    ],
                });
            });
        }
    },
    magnificPopup() {
        let videoLink = $('.modal-link-video');
        if (videoLink) {
            videoLink.magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    },
    masthead() {
        /** MASTHEAD PRGRESSIVE IMAGES **/
        var masthead = document.querySelector('.masthead'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

        if (masthead && placeholderOverlay) {
            // Load full size image. When loaded, fade our placeholder add it as bg to masthead
            var img = new Image();
            img.src = masthead.dataset.imageSrc;
            img.onload = function () {
                placeholderOverlay.classList.add('fade-out');
                masthead.style.backgroundImage = 'url(' + img.src + ')';
            };
        }
        /** END MASTHEAD PRGRESSIVE IMAGES **/
    },
    header() {
        /** FIXED HEADER ANIMATION **/
        var didScroll = false,
            scrollOffset = 100;

        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

        function scrollPage() {
            var sy = scrollY();
            if (sy > scrollOffset) {
                $('.site-header--fixed').addClass(
                    'site-header--scroll-triggered'
                );
            } else {
                $('.site-header--fixed').removeClass(
                    'site-header--scroll-triggered'
                );
            }
            didScroll = false;
        }

        window.addEventListener('load', scrollPage);
        window.addEventListener(
            'scroll',
            function () {
                // eslint-disable-line no-unused-vars
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 100);
                }
            },
            false
        );
        /** END FIXED HEADER ANIMATION **/

        // Mobile Icon
        $('.mobile-nav-icon').on('click', function () {
            $(this).toggleClass('mobile-nav-icon--active');
            $('.site-header').toggleClass('site-header--mobile-nav-active');
            $('body').toggleClass('mobile-nav-active');
        });

        // Disable click on mobile
        $('.mobile-menu__item--parent .sub-menu-toggle').on(
            'click',
            function () {
                $(this)
                    .parent('.mobile-menu__item')
                    .toggleClass('mobile-menu__item--opened');
            }
        );

        // Header active state on mouseover
        let headerMenuItems = document.querySelectorAll('.main-menu__item');
        let header = document.querySelector('.site-header');

        headerMenuItems.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                header.classList.add('site-header--active');
            });
            item.addEventListener('mouseleave', function () {
                header.classList.remove('site-header--active');
            });
        });

        /**  SEARCH OVERLAY **/
        const searchIcon = document.querySelector('.site-header__search-icon');
        const siteSearch = document.querySelector('.site-search');
        const siteSearchClose = document.querySelector('.site-search__close');

        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            header.classList.toggle('site-header--active');
            siteSearch.classList.toggle('site-search--active');
            setTimeout(() => {
                $('.site-search__form input[type="text"]').focus();
            }, 500);
        });
        siteSearchClose.addEventListener('click', () => {
            header.classList.remove('site-header--active');
            siteSearch.classList.remove('site-search--active');
        });
        /**  END SEARCH OVERLAY **/
    },
    mainNavAccessibility() {
        let $mainNavigationTopLevelItemLinks = $(
            '.site-header .main-menu > .main-menu__item--parent > button'
        );

        if ($mainNavigationTopLevelItemLinks.length) {
            $mainNavigationTopLevelItemLinks.each(function () {
                $(this).prev('a').attr('aria-haspopup', 'true');
                $(this).on('click', function () {
                    $(this).closest('li').toggleClass('sub-menu-open');
                    $(this).attr('aria-expanded', 'true');
                });
            });
        }
    },
    queryFilter() {
        // Overrides to Visceral Query Filter plugin
        // Append a div that can be used for toggle on mobile
        let queryFilter = document.querySelector('#visc-qf-posts');

        if (queryFilter) {
            let filterToggle = document.createElement('div');
            filterToggle.classList.add('visc-query-filter__toggle');
            filterToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" viewBox="0 0 21 13" fill="none"><path d="M3.94135 5.20609H17.0587V7.79391H3.94135V5.20609ZM0 0H21V2.58782H0V0ZM7.8827 10.3817H13.1173V13H7.8827V10.3817Z" fill="#69B1CC" /></svg><span>Filters</span><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><circle cx="15.0001" cy="15.0001" r="14.0001" transform="rotate(-180 15.0001 15.0001)" stroke="#69B1CC" stroke - width="2" /><path d="M14.3336 15.6669H9.66691C9.47247 15.6669 9.31275 15.6044 9.18774 15.4794C9.06274 15.3544 9.00024 15.1946 9.00024 15.0002C9.00024 14.8057 9.06274 14.646 9.18774 14.521C9.31275 14.396 9.47247 14.3335 9.66691 14.3335H14.3336H15.6669H20.3336C20.5281 14.3335 20.6878 14.396 20.8128 14.521C20.9378 14.646 21.0003 14.8057 21.0003 15.0002C21.0003 15.1946 20.9378 15.3544 20.8128 15.4794C20.6878 15.6044 20.5281 15.6669 20.3336 15.6669H15.6669H14.3336Z" fill="#69B1CC"/><path d="M14.3334 14.3335L14.3334 9.66685C14.3334 9.47241 14.3959 9.31268 14.5209 9.18768C14.6459 9.06268 14.8056 9.00018 15.0001 9.00018C15.1945 9.00018 15.3542 9.06268 15.4792 9.18768C15.6042 9.31268 15.6667 9.47241 15.6667 9.66685L15.6667 14.3335L15.6667 15.6669L15.6667 20.3336C15.6667 20.528 15.6042 20.6877 15.4792 20.8127C15.3542 20.9377 15.1945 21.0002 15.0001 21.0002C14.8056 21.0002 14.6459 20.9377 14.5209 20.8127C14.3959 20.6877 14.3334 20.528 14.3334 20.3336L14.3334 15.6669L14.3334 14.3335Z" fill="#69B1CC"/></svg>';
            queryFilter.prepend(filterToggle);

            // On click, toggle the filter
            filterToggle.addEventListener('click', () => {
                queryFilter.classList.toggle('visc-query-filter__form--active');
            });
        }
    },
    ajaxLoadMore() {
        // AJAX Load More
        function visc_load_more() {
            // eslint-disable-next-line no-undef
            if (visceral_vars !== undefined) {
                var data = {
                    action: 'visc_load_more',
                    // eslint-disable-next-line no-undef
                    query: visceral_vars.query,
                    // eslint-disable-next-line no-undef
                    paged: visceral_vars.current_page,
                    // eslint-disable-next-line no-undef
                    security: visceral_vars.security,
                };

                var $button = $('.btn--load-more');

                $.ajax({
                    // eslint-disable-next-line no-undef
                    url: visceral_vars.ajaxurl, // AJAX handler
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                    },
                    complete: function () {
                        this.itemReveal();
                    },
                    success: function (data) {
                        $button.blur();
                        if (data) {
                            $button.find('span').text('Load More');

                            var $postsContainer = $(
                                '.posts-list-container > div'
                            );
                            $postsContainer.append(data);
                            // eslint-disable-next-line no-undef
                            visceral_vars.current_page++;
                            // eslint-disable-next-line no-undef
                            if (
                                // eslint-disable-next-line no-undef
                                visceral_vars.current_page ==
                                // eslint-disable-next-line no-undef
                                visceral_vars.max_page
                            ) {
                                $button.remove(); // if last page, remove the button
                            }
                        } else {
                            $button.remove(); // if last page, remove the button
                        }
                    },
                });
            }
        }

        $('.btn--load-more').on('click', function () {
            visc_load_more();
        });
    },
    socialShare() {
        /**  SOCIAL SHARE OVERLAY **/
        const shareLink = document.querySelector('.visc-social-share-btn');
        const socialShare = document.querySelector('.visc-social-share');
        const socialShareClose = document.querySelector(
            '.visc-social-share__close'
        );

        if (socialShare) {
            shareLink.addEventListener('click', () => {
                // console.log(shareLink);
                socialShare.classList.add('visc-social-share--active');
            });
            socialShareClose.addEventListener('click', () => {
                socialShare.classList.remove('visc-social-share--active');
            });
        }
        /**  END SOCIAL SHARE OVERLAY **/
    },
    video() {
        // Autoplay video iframe on image overlay click
        let videoWidget = document.querySelectorAll('.elementor-widget-video');

        if (videoWidget) {
            videoWidget.forEach((widget) => {
                let video = widget.querySelector('iframe');
                let overlay = widget.querySelector('.elementor-custom-embed-image-overlay');

                overlay.addEventListener('click', () => {
                    video.src += '&autoplay=1';
                    video.setAttribute('allow', 'autoplay');
                    // overlay.classList.add('hidden');
                    console.log('clicked');
                });
            }
            );
        }
    },
    init() {
        // JavaScript to be fired on all pages

        /** GLOBAL VARIABLES */
        // var body = document.querySelector('body');
        /** END GLOBAL VARIABLES */

        // Accordions
        this.accordions();

        // Misc. link behaviors
        this.links();

        // Global reveal animations (consider commenting out this and 'gsap' and 'ScrollTrigger' import if not in use)
        this.itemReveal();

        // Slider (consider commenting out this and 'slick-carousel' import if not in use)
        this.slider();

        // Modals (consider commenting out this and 'magnific-popup' import if not in use)
        this.magnificPopup();

        // Masthead
        this.masthead();

        // Header
        this.header();

        // Main Nav Accessibility
        this.mainNavAccessibility();

        // Load more
        this.ajaxLoadMore();

        // QUery filter additions
        this.queryFilter();

        // Social share
        this.socialShare();

        // Videos
        this.video();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js